<template>
  <div class="card-body px-2 py-1 chart-block">
    <div class="tabbed">
      <input
        type="radio"
        :id="'tab' + i + 'b'"
        name="css-tabs3"
        v-for="(emergencyEvent, i) in eventType"
        :key="i + 'a'"
        @change="selectedEvent = i"
        :checked="i === 0"
      />
      <ul class="nav nav-tabs nav-tabs-custom faq-tab-box tabs sm-wrap">
        <li
          class="tab px-0 nav-item flex-fill"
          v-for="(emergencyEvent, i) in eventType"
          :key="i + 'm'"
        >
          <label
            class="nav-link py-1 text-center h-100"
            :for="'tab' + i + 'b'"
            :class="setEventLabelClass(emergencyEvent)"
            >{{ emergencyEvent }}</label
          >
        </li>
      </ul>
      <div
        class="tab-content event-area"
        v-for="(emergencyEvent, i) in eventType"
        :key="i"
      >
        <h1 class="text-center text-primary-emphasis" v-if="!eventList">
          目前尚無事件
        </h1>
        <div class="z-depth-1-half" v-if="eventList">
          <table class="table shadow-sm" id="eventTable">
            <thead class="table-dark">
              <tr class="">
                <th class="w-25">地點</th>
                <th class="w-25" v-if="i === 0">事件種類</th>
                <th class="w-25">時間<button @click="toggleSortTime" class="sort-btn" ><i :class="isAscending ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i></button></th>
                <th class="w-25" v-if="i === 7">狀態</th>

                <th v-if="i !== 7">狀態</th>
              </tr>
            </thead>
            <tbody class="table-group-divider">
              <tr v-for="item in eventList">
                <td>{{ item.ScenicAreaName }}</td>
                <td v-if="i === 0">{{ item.eventType }}</td>
                <td>{{ getTime(item.eventTime) }}</td>
                <td>{{ item.dismissContent }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <rightBtn :propEventList="propEventList"></rightBtn>
  </div>
</template>

<script>
import moment from "moment";
import CONST from "../utils/const";
import Utils from "../utils/utils";
import { mapState, mapGetters } from "vuex";
import rightBtn from "../components/allEmergencyEventBtn.vue";
// import { getControlHistoryByTimeInterval } from "../../../api/eastCoastDataApi/scenicPlace/ControlHistoryApi";

import { getControlHistoryByTimeInterval } from "../api/eastCoastDataApi/scenicPlace/ControlHistoryApi";

export default {
  components: { rightBtn },
  data() {
    return {
      dataInterval: null,
      selectedEvent: "",
      table: null,
      eventType: [
        "全部",
        "緊急求救",
        "容留上限",
        "違規",
        "天氣風險",
        "公廁維運",
        "管制",
        "設備",
      ],

      // startTime: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      // endTime: moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      //調整為測試機內指定日期範圍資料
      // startTime: "2022-12-17T00:00:00",
      // endTime: "2022-12-17T23:59:59",
      eventList: [],
      propEventList:[],
      eventArray:[],
      emergencyEventData: [],
      disasters: [],
      parkingLimitData: [],
      violationData: [],
      deviceErrorData: [],
      controlHistoryData: [],
      iotEventData:[],
      isAscending: true,
    };
  },

  methods: {
    getTime: function (time) {
      if (Utils.isEmptyObject(time)) {
        return "-";
      }
      return moment(time).format("YYYY/MM/DD HH:mm");
    },

    getDeviceTypeName: function (deviceType) {
      const deviceTypeName = CONST.EAST_COAST_DEVICE_TYPE_ENUM[deviceType];
      if (deviceTypeName) {
        return `${deviceTypeName}`;
      } else {
        return "UnknownType";
      }
    },
    async setEventType() {
     
       switch (this.selectedEvent) {
        default:
          this.eventList = this.emergencyEventData
            .concat(this.parkingLimitData)
            .concat(this.disasters)
            .concat(this.violationData)
            .concat(this.deviceErrorData)
            .concat(this.controlHistoryData)
            .concat(this.iotEventData);

          if (Object.keys(this.eventList).length > 0) {
            Utils.setEventDataTimeDesc(this.eventList);
            this.getPropEventList();
          } else {
            this.eventList = false;
          }
          
          break;

        case 0:
          this.eventList = this.emergencyEventData
            .concat(this.parkingLimitData)
            .concat(this.disasters)
            .concat(this.violationData)
            .concat(this.deviceErrorData)
            .concat(this.controlHistoryData)
            .concat(this.iotEventData);

          if (Object.keys(this.eventList).length > 0) {
            Utils.setEventDataTimeDesc(this.eventList);
            this.getPropEventList();

          } else {
            this.eventList = false;
          }

          break;

        case 1:
          if (Object.keys(this.emergencyEventData).length > 0) {
            this.eventList = this.emergencyEventData;
            Utils.setEventDataTimeDesc(this.eventList);
            this.getPropEventList();
          } else {
            this.eventList = false;
          }

          break;

        case 2: //容留上限
          if (Object.keys(this.parkingLimitData).length > 0) {
            this.eventList = this.parkingLimitData;
            Utils.setEventDataTimeDesc(this.eventList);
            this.getPropEventList();
          } else {
            this.eventList = false;
          }

          break;

        case 3: //違規
          if (Object.keys(this.violationData).length > 0) {
            this.eventList = this.violationData;
            Utils.setEventDataTimeDesc(this.eventList);
            this.getPropEventList();
          } else {
            this.eventList = false;
          }

          break;

        case 4: //天氣風險
          this.eventList = this.disasters;
          if (Object.keys(this.disasters).length > 0) {
            this.eventList = this.disasters;
            Utils.setEventDataTimeDesc(this.eventList);
            this.getPropEventList();
          } else {
            this.eventList = false;
          }

          break;

        case 5: //公廁維護 
        if (Object.keys(this.iotEventData).length > 0) {
            this.eventList = this.iotEventData;
            Utils.setEventDataTimeDesc(this.eventList);
            this.getPropEventList();
          } else {
            this.eventList = false;
          }

          break;

          
          case 6: //管制
            if (Object.keys(this.controlHistoryData).length > 0) {
              this.eventList = this.controlHistoryData;
              Utils.setEventDataTimeDesc(this.eventList);
              this.getPropEventList();
            } else {
              this.eventList = false;
            }
            break;
        case 7: //設備異常
          if (Object.keys(this.deviceErrorData).length > 0) {
            this.eventList = this.deviceErrorData;
            Utils.setEventDataTimeDesc(this.eventList);
            this.getPropEventList();
          } else {
            this.eventList = false;
          }

          break;

      }
    },

    async getPropEventList(){
      //緊急求救、設備、違規事件重新將 ScenicAreaName
      const deviceErrorDataRename = this.deviceErrorData.map((e) => {
          const deviceError = {};
          deviceError.scenicAreaId = e.scenicAreaId;
          deviceError.ScenicAreaName = e.scenicAreaName;
          deviceError.eventTime = e.eventTime;
          deviceError.dismissContent = e.dismissContent;
          deviceError.eventType = "設備";
          return deviceError;
        });
        const emergencyEventDataRename = this.emergencyEventData.map((e) => {
          const emergencyEvent = {};
          emergencyEvent.scenicAreaId = e.scenicAreaId;
          emergencyEvent.ScenicAreaName =e.scenicAreaName;
          emergencyEvent.eventTime = e.eventTime;
          emergencyEvent.dismissContent = e.dismissContent;
          emergencyEvent.eventType = "緊急求救";
          return emergencyEvent;
        });
        const violationDataRename = this.violationData.map((e) => {
          const violation = {};
          violation.ScenicAreaName = e.scenicAreaName;
          violation.eventTime = e.eventTime;
          violation.scenicAreaId =  e.scenicAreaId; // 僅有三仙台有違規闖入
          violation.dismissContent = e.dismissContent;
          violation.eventType = "違規";
          return violation;
        });
        

      this.propEventList = emergencyEventDataRename
            .concat(this.parkingLimitData)
            .concat(this.disasters)
            .concat(violationDataRename)
            .concat(deviceErrorDataRename)
            .concat(this.controlHistoryData)
            .concat(this.iotEventData);

        // console.log( "getPropEventList",this.propEventList)
        // this.getEventLabelClass();
      
    },

    async getEventLabelClass(){

      this.eventArray = [...new Set(this.propEventList.map(item => item.eventType))];
      //取得不重複ScenicAreaName重組陣列
      if(this.eventArray.length>0){
        this.eventArray.push("全部");
      }
      // console.log("eventArray",this.eventArray)

    },
    setEventLabelClass(item){
      if(this.eventArray.includes(item)){
        return "bg-danger";
      }
      

    },

    toggleSortTime(){
      this.isAscending = !this.isAscending;
      // console.log("event",this.eventList)
        
        this.sortData();
    },

    sortData(){
      if(this.isAscending){
      Utils.setEventDataTimeAsc(this.eventList)
    }else{
      Utils.setEventDataTimeDesc(this.eventList)
    }},

    getCarType(type){
      switch (type) {
        case "compact":
          return "小型車";
        case "fullSize":
          return "大型車(大型巴士)";
        case "smallBus":
          return "大型車(小型巴士)";
        case "truck":
          return "大型車(卡車)";
        case "motorcycle":
          return "機車";
      }
    },
    


  },
  computed: {
    ...mapGetters("scenicArea", { myScenicAreaList: "getMyScenicArea" }),
    ...mapGetters("emergencyEvent", { emergencyEventList: "getEvents" }),
    ...mapGetters("parkingAvailabilityRate", {
      parkingLimitList: "getAllParkingAvailabilityRate",
    }),
    ...mapGetters("iotEvent",{ iotEventList:"getIotEventData" }),
    ...mapGetters("violation", { violationList: "getViolationData" }),
    ...mapGetters("disasterMonitor", { disasterList: "getAllDisaster" }),
    ...mapState("deviceError", { deviceErrorList: "deviceDailyErrorList" }),
    ...mapState("controlHistory", {
      controlHistoryList: "controlHistoryByTimeInterval",
    }),
  },
  watch: {

    myScenicAreaList: {
      handler() {
        // this.setEventType();
      },
      // immediate: true,
    },
    selectedEvent: {
      handler(){
        this.setEventType();
      },
      // immediate:true,

    },
    
    propEventList:{
      handler(newVal){
    
        if(newVal !== null && newVal !== undefined){
          this.getEventLabelClass();

        }
      },
      // immediate:true,
    },


    emergencyEventList: {
      handler(newVal) {
      
          this.emergencyEventData = newVal.map((e) => {
            const emergencyEvent = {};
            emergencyEvent.scenicAreaId = e.scenicAreaId;
            emergencyEvent.ScenicAreaName =`${e.scenicAreaName} ─ ${e.placeName}`;
            emergencyEvent.scenicAreaName = e.scenicAreaName ;
            emergencyEvent.eventTime = e.eventTime;
            emergencyEvent.dismissContent = e.dismissContent;
            emergencyEvent.eventType = "緊急求救";
            return emergencyEvent;
          });
          // Utils.setScenicAreaNamebyId();
          // this.setEventType();
 
        
      },
    },

    parkingLimitList: {
      handler(newVal) {
        // console.log("parkingLimitList",newVal)
        this.parkingLimitData = newVal.map((e) => {
          const parkingLimit = {};
          parkingLimit.scenicAreaId = e.scenicAreaId;
          parkingLimit.ScenicAreaName = e.scenicAreaName;
          parkingLimit.eventTime = e.startTime;
          parkingLimit.dismissContent =
            (e.warningLevel === "yellow" ? "警戒 - 已達八成" : "警戒 - 已達九成");
          parkingLimit.eventType = "容留上限";
          return parkingLimit;
        });
        // Utils.setScenicAreaNamebyId(this.parkingLimitData);
        // console.log("this.parkingLimitData",this.parkingLimitData)
        this.setEventType();

      },
    },

    violationList: {
      handler(newVal) {
        this.violationData = newVal.map((e) => {
          const violation = {};
          violation.ScenicAreaName = `${e.areaName} ─ ${e.publicPlaceName}`;
          violation.scenicAreaName = e.areaName;
          violation.scenicAreaId = e.areaId;
          violation.eventTime = e.dt;
          violation.dismissContent = Utils.getViolationType(e.violationType);
          violation.eventType = "違規";
          return violation;
        });
        // Utils.setScenicAreaNamebyId();
        this.setEventType();
      },
    },

    disasterList: {
      handler(newVal) {
        this.disasters = newVal.map((disaster) => ({
          ...disaster,
          eventType: "天氣風險",
        }));
        Utils.setScenicAreaNamebyId(this.disasters);
        Utils.setDisasterContent(this.disasters);
      },
    },

    deviceErrorList: {
      handler(newVal) {
        if(!Utils.isEmptyObject(newVal)){

          // console.log("newVal", newVal);
          this.deviceErrorData = newVal.map((e) => {
            const deviceError = {};
            deviceError.scenicAreaId = e.areaId;
            deviceError.ScenicAreaName = `${e.scenicAreaName} ─ ${e.publicPlaceName}`;
            deviceError.scenicAreaName = e.scenicAreaName ;
            deviceError.eventTime = e.happenTime;
            deviceError.dismissContent = `${
              e.deviceErrorType
            } ─ ${this.getDeviceTypeName(e.deviceType)}`;
            deviceError.eventType = "設備";
            return deviceError;
          });
          // Utils.setScenicAreaNamebyId();
          this.setEventType();
        }
      },
    },

    controlHistoryList: {
      handler(newVal) {
        // console.log("controlHistoryList",newVal)
        this.controlHistoryData = newVal.map((e) => {
          const controlHistory = {};
          controlHistory.scenicAreaId = e.scenicAreaId;
          controlHistory.ScenicAreaName = e.scenicAreaName;
          controlHistory.eventTime = e.controlStartTime;
          controlHistory.dismissContent = "啟動管制";
          controlHistory.eventType = "管制";

          return controlHistory;
        });
        // Utils.setScenicAreaNamebyId();
        // this.setEventType();
      },
    },
    iotEventList:{
      handler(newVal){
        // console.log("watch",newVal)

        Utils.setScenicAreaNamebyId(newVal);
        // console.log("newVal",newVal)
        this.iotEventData = newVal.map((e) => {
          const iotEvent = {};
          iotEvent.scenicAreaId = e.scenicAreaId;
          iotEvent.ScenicAreaName = `${e.ScenicAreaName}`;
          iotEvent.eventTime = e.eventTime;
          iotEvent.dismissContent = `${e.publicPlaceName} ${e.eventTypeName}-${e.infoPriority}`;
          iotEvent.eventType = "公廁維運";

          return iotEvent;
        });

        this.setEventType();
      }}

  },
  mounted() {
    // this.getControlHistory();
    // this.setEventType();
    // this.$nextTick(() => {
    //   this.setEventType();
    // });

    setTimeout(() => {
     this.setEventType();
        }, 1200);

    this.dataInterval = setInterval(async () => {
      this.setEventType();
    }, CONST.REFRESH_DAT_TIMER_MIN);

  },

  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval);
    this.dataInterval = null;
  },
};
</script>

<style lang="scss" scoped>
$max: 20;
@for $i from 1 through $max {
  .tabbed
    [type="radio"]:nth-of-type(#{$i}):checked
    ~ .tabs
    .tab:nth-of-type(#{$i})
    label {
    background: #00ae9a !important;
    color: #fff;
  }

  .tabbed
    [type="radio"]:nth-of-type(#{$i}):checked
    ~ .tabs
    .tab:nth-of-type(#{$i})
    label:after {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@for $i from 1 through $max {
  .tabbed
    [type="radio"]:nth-of-type(#{$i}):checked
    ~ .tab-content:nth-of-type(#{$i}) {
    display: block;
    box-shadow: none;
  }
}

.nav-tabs li .nav-link:hover {
  background-color: #00ae9a;
  color: #fff;
  border-bottom: 0.8px solid #eee;
  border-top: 0.8px solid #eee;
}
.table th {
  position: sticky;
  top: 0;
}

.event-area {
  height: 16rem;
  min-height: 16rem;
  max-height: 16rem;

  overflow-y: scroll;
  overflow-x: scroll;

}

.chart-block {
  max-width: 550px;
  margin: 0 auto;
}

.sort-btn{
  border: none;
  background: none;
  color:white;
  padding: 0 0 0 5px;


  // background-color: none;
}

  .sort-btn i {
    font-size: 10px;
  }


  // 偵測螢幕大小，並且只在小於sm時換行


  .card-body .tabbed .sm-wrap{
        flex-wrap: nowrap;
      // min-width: 290px;

    @media  (max-width: 344px)  {
        flex-wrap: wrap;
      }

    @media  (min-width: 746px) and   (max-width: 980px) {
      //配合平板裝置+左側選單寬度
        flex-wrap: wrap;
      }
  }


</style>
